export interface ApiConfigResult {
  baseUrl: string;
  [propName: string]: any; // tslint:disable-line no-any
}

let configuration = {
    baseUrl: '',
}

let ran = false

export default (config?: any): ApiConfigResult => { // tslint:disable-line no-any
  if (process.env.NODE_ENV === 'development') {
    if (ran && config) {
      console.warn('API configuration was run multiple times')
    }
  }

  if (config) {
    configuration = {
      ...configuration,
      ...config,
    }
  }

  ran = true
  return configuration
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/api/configure.ts